import { Segment } from '@fxtr/i18n';
import config from '$config';

/** Maps customer-facing segments to the path segment used in garage webpage URLs. */
export const GARAGE_SEGMENT_PATHS = {
  [Segment.Fixter_UK]: 'garage',
  [Segment.Fixter_FR]: 'garage',
  [Segment.Motrio_UK]: 'garage-repairer',
  [Segment.Motrio_FR]: 'garage-reparateur',
  [Segment.Motrio_RO]: 'garage-reparateur',
  [Segment.Motrio_PL]: 'garage-reparateur',
  [Segment.Motrio_IT]: 'officina-riparatrice',
  [Segment.Motrio_ES]: 'taller-reparador',
  [Segment.Motrio_PT]: 'oficina-reparadora',
  [Segment.Renault_MA]: 'concessionaire',
};

function stripProtocolAndTrailingSlash(url) {
  if (!url) return '';
  return url.replace(/^https?:\/\//, '').replace(/\/$/, '');
}

/**
 * Resolves the public hostname for a garage webpage from application config.
 * Prefers explicit `garagePublicHostnames` entries, then falls back to landing URLs.
 */
export function getGaragePublicHostname(segment) {
  const configuredHostname = config.garagePublicHostnames?.[segment];
  if (configuredHostname) {
    return stripProtocolAndTrailingSlash(configuredHostname);
  }

  if (segment === Segment.Fixter_UK && config.landingUrl) {
    return stripProtocolAndTrailingSlash(config.landingUrl);
  }

  if (segment === Segment.Fixter_FR && config.landingUrlFr) {
    return stripProtocolAndTrailingSlash(config.landingUrlFr);
  }

  return null;
}

export function getGarageWebpagePath(segment) {
  return GARAGE_SEGMENT_PATHS[segment] || null;
}

/** Display path without protocol, e.g. www.fixter.co.uk/garage/my-garage */
export function buildGarageWebpageDisplayUrl(segment, slug) {
  const hostname = getGaragePublicHostname(segment);
  const path = getGarageWebpagePath(segment);

  if (!hostname || !path || !slug) {
    return null;
  }

  return `${hostname}/${path}/${slug}`;
}

/** Full URL with protocol for clipboard copy and opening in a new tab. */
export function buildGarageWebpageUrl(segment, slug) {
  const displayUrl = buildGarageWebpageDisplayUrl(segment, slug);
  if (!displayUrl) {
    return null;
  }

  return `https://${displayUrl}`;
}
